module.exports = __webpack_public_path__ + "static/uv-logo-8dc040974c76ae9593bc22a056bb8359.png";